import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { AccountsDashboard } from "./components/Accounts";
import AccountPage from "./components/Accounts/AccountPage";
import { AuditBMUsers } from "./components/Audit";
import ContractsList from "./components/Contracts/ContractsList";
import { ClientsDashboard, InvoicesDashboard } from "./components/Invoices";
import { Leads } from "./components/Leads";
import { MembersInformation } from "./components/MembersInformation";
import { ProfessionalServicesKPIs } from "./components/ProfessionalServices";
import { Home } from "./components";
import { SalesDashboard } from "./components/Sales";
import SprintPage from "./components/Sprints/SprintPage";
import UserProfile from "./components/UserProfile/UserProfile";

// Projects components
import ProjectsDashboard from "./components/Projects/ProjectsDashboard";
import ProjectPage from "./components/Projects/ProjectPage";

// Billing components
import Billing from "./components/Billing/Billing";
import BillingSettingsLayout from "./components/Billing/Settings/Settings";
import ClientsList from "./components/Billing/ClientsList";
import ClientDetail from "./components/Billing/ClientDetail/ClientDetail";
import CompanyInformationManagement from "./components/Billing/Settings/CompanyInformation/CompanyInformationManagement";
import InvoiceManager from "./components/Billing/InvoiceEditor/InvoiceManager";
import InvoicesList from "./components/Billing/InvoicesList";
import PaymentMethodsManagement from "./components/Billing/Settings/PaymentMethodsManagement";
import TaxRatesManagement from "./components/Billing/Settings/TaxRatesManagement";
import TermsManagement from "./components/Billing/Settings/TermsManagement";

import PrivateRoute from "./shared/PrivateRoute";

interface PlaceholderProps {
  name: string;
}

const Placeholder: React.FC<PlaceholderProps> = ({ name }) => (
  <div className="p-4 text-2xl">{name} ...</div>
);

export class Main extends React.Component {
  render() {
    return (
      <div key={"unique"} className={"main dark:bg-gray-900 dark:text-white"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/accounts/:id" element={<AccountPage />} />
          <Route path="/accounts/" element={<AccountsDashboard />} />
          <Route path="/projects/:id" element={<ProjectPage />} />
          <Route path="/projects" element={<ProjectsDashboard />} />
          <Route path="/users/:login">
            <Route index element={<UserProfile />} />
            <Route path=":sprintId" element={<UserProfile />} />
          </Route>
          <Route path="/sprints/:id" element={<SprintPage />} />
          <Route
            path="/professional_services_kpis"
            element={<ProfessionalServicesKPIs />}
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <MembersInformation />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <PrivateRoute>
                <InvoicesDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <ClientsDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/leads"
            element={
              <PrivateRoute>
                <Leads />
              </PrivateRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <PrivateRoute>
                <SalesDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <PrivateRoute>
                <AuditBMUsers />
              </PrivateRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <PrivateRoute>
                <Billing />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="clients" replace />} />
            <Route path="clients">
              <Route index element={<ClientsList />} />
              <Route path=":clientId" element={<ClientDetail />} />
            </Route>
            <Route path="invoices">
              <Route index element={<InvoicesList />} />
              <Route path="new" element={<InvoiceManager />} />
              <Route path=":invoiceId" element={<InvoiceManager />} />
            </Route>
            <Route path="contracts" element={<ContractsList />} />
            <Route path="payments" element={<Placeholder name="Payments" />} />
            <Route path="settings" element={<BillingSettingsLayout />}>
              <Route index element={<Navigate to="company-info" replace />} />
              <Route
                path="company-info"
                element={<CompanyInformationManagement />}
              />
              <Route path="taxes" element={<TaxRatesManagement />} />
              <Route path="terms" element={<TermsManagement />} />
              <Route
                path="payment-methods"
                element={<PaymentMethodsManagement />}
              />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    );
  }
}
